module.exports = __webpack_public_path__ + "media/images/empath-10600da175f694bff79ae9c23b79165b.png";